import Vue from 'vue'
import { httpAgent } from './axiosConfig'

const vueInstance = new Vue()

function api_post(url, data, loading?: boolean) {
  return httpAgent({
    method: 'POST',
    url,
    data,
    loading: loading ? true : false,
    all: true
  })
}
function params_post(url, data, loading?: boolean) {
  return httpAgent({
    method: 'POST',
    url,
    params: data,
    loading: loading ? true : false,
    all: true,
    qs: true
  })
}
function stringfy_post(url, data, loading?: boolean) {
  return httpAgent({
    method: 'POST',
    url,
    data: JSON.stringify(data),
    loading: loading ? true : false,
    all: true,
    headers: { 'content-type': 'application/json' }
  })
}
function api_get(url, data, loading?: boolean) {
  return httpAgent({
    method: 'GET',
    url,
    params: data,
    loading: loading ? true : false,
    all: true
  })
}
function http_withoutcookie(url, data, loading?: boolean) {
  return httpAgent({
    method: 'POST',
    url,
    data,
    loading: loading ? true : false,
    all: true,
    withCredentials: false
  })
}

function errorTipWrapper(fn) {
  return (...args) => {
    return fn(...args).then((retData) => {
      if (!retData.success) {
        vueInstance.$message.error(retData && (retData.error || retData.msg || '(FE)未知错误'))
        if (!(retData && (retData.error || retData.msg))) {
          console.dir(retData)
        }
      }
      return retData
    })
  }
}

const wrapper_api_post = errorTipWrapper(api_post)
const wrapper_params_post = errorTipWrapper(params_post)
const wrapper_stringfy_post = errorTipWrapper(stringfy_post)
const wrapper_api_get = errorTipWrapper(api_get)

export {
  wrapper_api_post as api_post,
  wrapper_params_post as params_post,
  wrapper_stringfy_post as stringfy_post,
  wrapper_api_get as api_get,
  http_withoutcookie
}
